export function getStatboxDesktop() {
  if (typeof window === 'undefined') return null;
  return window.statboxDesktop || null;
}

export function isStatboxDesktop() {
  return Boolean(getStatboxDesktop()?.isDesktop);
}
